module.exports = __webpack_public_path__ + "static/media/Malamar_gaussian2.39d8e8b2.png";